export const GENERAL = {
  languageSwitcherLabel: 'language_label',
  languageNames: {
    en: 'language_en',
    pt: 'language_pt',
  },
  navigation: {
    home: 'nav_home',
    aboutUs: 'nav_about',
    projects: 'nav_projects',
    contact: 'nav_contact',
    joinUs: 'nav_joinus'
  },
  buttons: {
    contact: 'button_contact',
    form: 'button_form',
    more: 'button_more',
    top: 'button_top',
  },
  footer: {
    caduProduct: 'footer_cadu_product',
  },
}

export const SEO = {
  home: {
    title: 'seo_home_title',
    description: 'seo_home_description',
  },
  aboutUs: {
    title: 'seo_aboutus_title',
    description: 'seo_aboutus_description',
  },
  projects: {
    title: 'seo_projects_title',
    description: 'seo_projects_description',
  },
  contact: {
    title: 'seo_contact_title',
    description: 'seo_contact_description',
  },
}

export const HOME = {
  title: 'home_title',
  subtitle: 'home_subtitle',
  intro: {
    innovation: { 
      title: 'home_innovation_title',
      subtitle: 'home_innovation_subtitle',
    },
    collab: { 
      title: 'home_collab_title',
      subtitle: 'home_collab_subtitle',
    },
    quality: { 
      title: 'home_quality_title',
      subtitle: 'home_quality_subtitle',
    },
  },
  conception: {
    sectionName: 'home_conception',
    title: 'home_conception_title',
    subtitle: 'home_conception_subtitle',
    search: 'home_conception_search',
    develop: 'home_conception_develop',
    idea: 'home_conception_idea',
    delivery: 'home_conception_delivery',
  },
  projects: {
    title: 'home_projects_title',
    subtitle: 'home_projects_subtitle',
    cards: {
      ideas: {
        title: 'home_projects_ideas_title',
        subtitle: 'home_projects_ideas_subtitle',
      },
      exp: {
        title: 'home_projects_exp_title',
        subtitle: 'home_projects_exp_subtitle',
      },
      commit: {
        title: 'home_projects_commit_title',
        subtitle: 'home_projects_commit_subtitle',
      },
    },
  },
  testimonial: {
    title: 'home_testimonial_title',
    subtitle: 'home_testimonial_subtitle',
  },
  contact: {
    title: 'home_contact_title',
    subtitle: 'home_contact_subtitle',
  },
}

export const ABOUT_US = {
  title: 'aboutus_title',
  subtitle: 'aboutus_subtitle',
  text: 'aboutus_text',
  dna: {
    title: 'aboutus_dna_title',
    cards: {
      geeks: {
        title: 'aboutus_geeks_title',
        text: 'aboutus_geeks_text',
      },
      cocreation: {
        title: 'aboutus_cocreation_title',
        text: 'aboutus_cocreation_text',
      },
      innovation: {
        title: 'aboutus_innovation_title',
        text: 'aboutus_innovation_text',
      },
      inclusive: {
        title: 'aboutus_inclusive_title',
        text: 'aboutus_inclusive_text',
      },
    },
  },
  bottomSection: {
    main: 'aboutus_bottom_main',
    secondary: 'aboutus_bottom_secondary',
    contact: 'aboutus_bottom_contact',
    ctaText: 'aboutus_bottom_cta_text',
  },
}

export const PROJECTS = {
  title: 'projects_title',
  subtitle: 'projects_subtitle',
  guapo: 'projects_guapo',
  iaris: 'projects_iaris',
  baptistella: 'projects_baptistella',
  dws: 'projects_dws',
  bottomTitle: 'projects_bottom_title',
  bottomSubtitle: 'projects_bottom_subtitle',
}

export const CONTACT = {
  title: 'contact_title',
  subtitle: 'contact_subtitle',
}

export const FORM = {
  title: 'form_title',
  subtitle: 'form_subtitle',
  name: 'form_name',
  email: 'form_email',
  phone: 'form_phone',
  message: 'form_message',
}
